import { UseMutateFunction, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNetworkRequest } from '../../../../../../hooks/useNetworkRequest';
import { AxiosResponse } from 'axios';

export type ResumeValue = unknown;

type UseResumeSubmitMutationParams = {
  onClose: () => void;
  buildFormData: (file: NonNullable<ResumeValue>) => FormData;
  headers?: Record<string, string>;
};

const useResumeSubmitMutation = ({
  onClose,
  buildFormData,
  headers,
}: UseResumeSubmitMutationParams): {
  submitResume: UseMutateFunction<
    AxiosResponse<any> | null,
    unknown,
    { resume: ResumeValue },
    unknown
  >;
  isLoading: boolean;
} => {
  const queryClient = useQueryClient();
  const { axios } = useNetworkRequest();

  const { mutateAsync: submitResume, isLoading } = useMutation(
    (values: { resume: ResumeValue }) => {
      const file = values.resume;
      if (!file) {
        onClose();
        return Promise.resolve(null);
      }
      const formData = buildFormData(file);
      return axios.post(`/v3/professional/resume`, formData, headers ? { headers } : undefined);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['currentUser']);
      },
      onSuccess: () => {
        onClose();
      },
    },
  );

  return {
    submitResume,
    isLoading,
  };
};

export default useResumeSubmitMutation;
